import { router } from '@inertiajs/react'
import { formatDistanceToNow } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function submitComposioRefresh(
  connectedAccountId: string,
  options: { reloadProps: string[]; onFinish?: () => void; preserveState?: boolean; silent?: boolean },
) {
  router.post(
    '/dashboard/composio/refresh',
    { connected_account_id: connectedAccountId, silent: options.silent },
    {
      preserveScroll: true,
      preserveState: options.preserveState ?? true,
      only: options.reloadProps,
      onFinish: options.onFinish,
    },
  )
}

export function formatLastVerified(lastSyncedAt: string | null): string {
  if (!lastSyncedAt) return 'Nunca verificado'
  return `Verificado há ${formatDistanceToNow(new Date(lastSyncedAt), { locale: ptBR })}`
}

// Compact form for tight layouts: "agora" / "há 4m" / "há 2h" / "há 3d" / dd/MM.
// Paired with formatVerifiedAbsolute as a tooltip so precision isn't lost.
export function formatLastVerifiedShort(lastSyncedAt: string | null): string {
  if (!lastSyncedAt) return 'nunca verificado'
  const date = new Date(lastSyncedAt)
  const diffSec = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000))
  if (diffSec < 60) return 'agora'
  if (diffSec < 3600) return `há ${Math.floor(diffSec / 60)}m`
  if (diffSec < 86400) return `há ${Math.floor(diffSec / 3600)}h`
  if (diffSec < 2592000) return `há ${Math.floor(diffSec / 86400)}d`
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' }).format(date)
}

export function formatVerifiedAbsolute(lastSyncedAt: string | null): string {
  if (!lastSyncedAt) return 'Nunca verificado'
  const date = new Date(lastSyncedAt)
  return `Verificado em ${new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)}`
}
